import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { fetchPricing, setCoupon } from '../../store/pricingSlice'
import PartnerPage from 'js/pages/PartnerPage/PartnerPage'
import HowItWorks from 'js/components/HowItWorks/HowItWorks'
import SocialProof from 'js/components/SocialProof/SocialProof'
import Testimonials from 'js/components/Testimonials/Testimonials'
import Modal from 'js/components/Modal/Modal'
import Button from 'js/components/Button/Button'

import messages from './messages'
import WhatIsLifesum from '../../components/WhatIsLifesum/WhatIsLifesum'
import { Meta } from 'react-head'
import useLocale from 'js/hooks/useLocale'

const GEFreePage = () => {
  const [hasError, setHasError] = useState(false)
  const dispatch = useDispatch()
  const { language } = useLocale()

  useEffect(() => {
    dispatch(fetchPricing('ge-healthahead', 'USD')).catch(() =>
      setHasError(true),
    )
    dispatch(setCoupon('ge-healthahead'))
  }, [dispatch])

  const ctaButton = !hasError && (
    <>
      <p className="mb-24">
        <span className="type-upper-fat mb-8 inline-block rounded-full bg-Bg px-16 pt-2 text-black">
          <FormattedMessage
            id="features_page_splash_free"
            defaultMessage="Free!"
          />
        </span>
        <br />
        <span className="type-20-demibold">
          <FormattedMessage
            id="HomeChef_MainHeading"
            defaultMessage="Claim your 3 Month Premium Membership"
          >
            {([text]) => text.replace(3, 12)}
          </FormattedMessage>
        </span>
      </p>
      <Link
        data-uid="claim_offer_button"
        className="c-button c-button--premium"
        to="/gehealthahead/account"
      >
        <span>
          <FormattedMessage
            id="Premium_signup_cta_campaign"
            defaultMessage="Claim offer"
          />
        </span>
      </Link>
    </>
  )

  const currentDate = new Date()
  const year =
    currentDate.getMonth() >= 11 // December
      ? currentDate.getFullYear() + 1
      : currentDate.getFullYear()

  return (
    <PartnerPage
      partner="gehealthahead"
      heroImage={require('./hero-bg-fearless.jpg')}
      heroImageMobile={require('./hero-bg-fearless-mobile.jpg')}
      heroHeading={
        <>
          <FormattedMessage id="Jumbotron.intro.title" />
          {language === 'fr' ||
          language === 'ru' ||
          language === 'it' ||
          language === 'pt' ? (
            ' '
          ) : (
            <br />
          )}
          <FormattedMessage id="Jumbotron.intro.subtitle" />
        </>
      }
      heroSubHeading={<FormattedMessage {...messages.heroSubHeading} />}
      heroMessage={null}
      ctaButton={ctaButton}
      rootUrl={'/gehealthahead'}
      transparentHeader={true}
      redeemCode="ge-healthahead"
      hideCoupon={true}
      initialPlan={12}
    >
      <Meta name="robots" content="noindex" />
      <div
        className="mx-auto mb-72 mt-40 max-w-1024 text-left lg:text-center"
        id="start"
      >
        <div className="mx-24 lg:mx-auto lg:w-4/5">
          <div className="leading-body type-24 lg:mx-48">
            <p className="mb-24 py-64">
              <FormattedMessage {...messages.introText} values={{ year }}>
                {([text]) => text.replace('50', '100')}
              </FormattedMessage>
            </p>
            <p>
              <FormattedMessage {...messages.callOut}>
                {([text]) => text.replace('50', '100')}
              </FormattedMessage>
            </p>
          </div>
        </div>
      </div>
      <div className="pb-24 text-left lg:pb-48 lg:text-center">
        <div className="mx-auto px-20 lg:px-32">
          <h2 className="mb-24 type-40 lg:mb-36 lg:type-56">
            <FormattedMessage {...messages.howToHeading} />
          </h2>
          <HowItWorks />
        </div>
      </div>
      <div className="bg-Bg pb-24 pt-40 text-center lg:pt-56">
        <div className="o-width-limiter">
          <h2 className="mb-24 type-40 lg:mb-36 lg:type-56">
            <FormattedMessage {...messages.whatsIncludedHeading} />
          </h2>
          <br />
          <WhatIsLifesum />
        </div>
      </div>
      <div>
        <SocialProof />
        <div className="mx-auto px-20 md:px-64 lg:max-w-[80%]">
          <Testimonials />
        </div>
        <div className="o-width-limiter py-64 text-center">{ctaButton}</div>
      </div>
      {hasError && (
        <Modal onClose={() => window.location.reload()}>
          <FormattedMessage {...messages.errorMessage} />
          <div className="mt-16">
            <Button onClick={() => window.location.reload()}>
              <FormattedMessage {...messages.tryAgain} />{' '}
            </Button>
          </div>
        </Modal>
      )}
    </PartnerPage>
  )
}

GEFreePage.propTypes = {
  fetchPricing: PropTypes.func,
  setCoupon: PropTypes.func,
}

export default GEFreePage
